import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const pixelTrack = (event, params) => {
  if (window.fbq) window.fbq("track", event, params);
};

export const pixelTrackCustom = (event, params) => {
  if (window.fbq) window.fbq("trackCustom", event, params);
};

export const fireAdGenerated = async () => {
  try {
    const res = await axios.post(`${API}/api/track/ad-generated`, {}, { withCredentials: true });
    pixelTrackCustom("AdGenerated", { first_ad: !!res.data.first_ad });
  } catch {
    // tracking must never break the app
  }
};
